// Events
import { CART_CHANGED, THEME_CART_UPDATED } from 'events';
import { component } from 'picoapp';

// Utils
import choozy from 'utils/choozy';

export default component((node, ctx) => {
  const { button } = choozy(node);

  ctx.on(CART_CHANGED, () => {
    button.classList.add('is-loading');
    button.disabled = true;
  });

  ctx.on(THEME_CART_UPDATED, () => {
    button.classList.remove('is-loading');
    button.disabled = false;
  });
});
